
export default function config($routeProvider) {
	$routeProvider
		.when('/preincidencia', {
			templateUrl: 'templates/preincidencias/preincidencias-list.html',
			controller: 'preIncidenciasController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/preincidencia/:id', {
			templateUrl: 'templates/preincidencias/preincidencias-detalle.html',
			controller: 'preIncidenciasController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/incidencia', {
			templateUrl: 'templates/incidencia/incidencias-list.html',
			controller: 'incidenciasController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/incidencia/new', {
			templateUrl: 'templates/incidencia/incidencias-new.html',
			controller: 'incidenciasController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/incidencia/:id', {
			templateUrl: 'templates/incidencia/incidencias-view.html',
			controller: 'incidenciasController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/ott', {
			templateUrl: 'templates/ott/ott-list.html',
			controller: 'ottController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/ott/new/', {
			templateUrl: 'templates/ott/ott-new.html',
			controller: 'ottController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/ott/por_agendar/', {
			templateUrl: 'templates/ott/ott_por_agendar.html',
			controller: 'ottController',
			resolve: { method: function () { return 'por_agendar'; } }
		})
		.when('/ott/por_agendar/:id', {
			templateUrl: 'templates/ott/ott_por_agendar_view.html',
			controller: 'ottController',
			resolve: { method: function () { return 'por_agendar_view'; } }
		})
		.when('/ott/new/:id', {
			templateUrl: 'templates/ott/ott-new.html',
			controller: 'ottController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/ott/:id', {
			templateUrl: 'templates/ott/ott-view.html',
			controller: 'ottController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/ott/download/pdf', {
			templateUrl: 'templates/ott/ott-pdf-filter.html',
			controller: 'ottController',
			resolve: { method: function () { return 'pdfFilter'; } }
		})
		.when('/cargar-ott', {
			templateUrl: 'templates/ott/ott-carga.html',
			controller: 'ottController',
			resolve: { method: function () { return 'carga'; } }
		})
		.when('/inventario/general', {
			templateUrl: 'templates/inventario/inventario-general.html',
			controller: 'inventarioController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/inventario/ubicacion', {
			templateUrl: 'templates/inventario/inventario-ubicacion.html',
			controller: 'inventarioController',
			resolve: { method: function () { return 'ubicacion'; } }
		})
		.when('/inventario/nuevo', {
			templateUrl: 'templates/inventario/inventario-new.html',
			controller: 'inventarioController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/inventario/carga', {
			templateUrl: 'templates/inventario/inventario-carga.html',
			controller: 'inventarioController',
			resolve: { method: function () { return 'carga'; } }
		})
		.when('/inventario/completar_list', {
			templateUrl: 'templates/inventario/inventario-completar-list.html',
			controller: 'inventarioController',
			resolve: { method: function () { return 'completar_list'; } }
		})
		.when('/inventario/completar_list/:id', {
			templateUrl: 'templates/inventario/inventario-completar-view.html',
			controller: 'inventarioController',
			resolve: { method: function () { return 'completar_view'; } }
		})
		.when('/inventario/:id', {
			templateUrl: 'templates/inventario/inventario-view.html',
			controller: 'inventarioController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/inventario/ubicacion/:ubicacion/:tipo_equipo', {
			templateUrl: 'templates/inventario/inventario-ubicacion-detalle.html',
			controller: 'inventarioController',
			resolve: { method: function () { return 'ubicacion-tipo'; } }
		})
		.when('/indicadores', {
			templateUrl: 'templates/indicadores/indicadores.html',
			controller: 'indicadoresController',
		})
		.when('/alertas', {
			templateUrl: 'templates/alertas/alertas-list.html',
			controller: 'alertasController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/alertas/new', {
			templateUrl: 'templates/alertas/alertas-new.html',
			controller: 'alertasController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/alertas/view/:id', {
			templateUrl: 'templates/alertas/alertas-view.html',
			controller: 'alertasController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/ubicaciones/', {
			templateUrl: 'templates/ubicaciones/ubicaciones-list.html',
			controller: 'ubicacionesController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/ubicaciones/new', {
			templateUrl: 'templates/ubicaciones/ubicaciones-new.html',
			controller: 'ubicacionesController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/ubicaciones/:id', {
			templateUrl: 'templates/ubicaciones/ubicaciones-view.html',
			controller: 'ubicacionesController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/tipo_equipos/', {
			templateUrl: 'templates/tipo_equipos/tipo_equipos-list.html',
			controller: 'tipoEquiposController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/tipo_equipos/new', {
			templateUrl: 'templates/tipo_equipos/tipo_equipos-new.html',
			controller: 'tipoEquiposController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/tipo_equipos/:id', {
			templateUrl: 'templates/tipo_equipos/tipo_equipos-view.html',
			controller: 'tipoEquiposController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/protocolos/', {
			templateUrl: 'templates/protocolos/protocolos-list.html',
			controller: 'protocolosController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/protocolos/new', {
			templateUrl: 'templates/protocolos/protocolos-new.html',
			controller: 'protocolosController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/protocolos/:id', {
			templateUrl: 'templates/protocolos/protocolos-view.html',
			controller: 'protocolosController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/tareas/', {
			templateUrl: 'templates/tareas/tareas-list.html',
			controller: 'tareasController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/tareas/new', {
			templateUrl: 'templates/tareas/tareas-new.html',
			controller: 'tareasController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/tareas/:id', {
			templateUrl: 'templates/tareas/tareas-view.html',
			controller: 'tareasController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/unidad_ejecutora/', {
			templateUrl: 'templates/unidadEjecutora/unidad_ejecutora-list.html',
			controller: 'unidadEjecutoraController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/unidad_ejecutora/new', {
			templateUrl: 'templates/unidadEjecutora/unidad_ejecutora-new.html',
			controller: 'unidadEjecutoraController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/unidad_ejecutora/:id', {
			templateUrl: 'templates/unidadEjecutora/unidad_ejecutora-view.html',
			controller: 'unidadEjecutoraController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/severidad/', {
			templateUrl: 'templates/severidad/severidad-list.html',
			controller: 'severidadController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/severidad/new', {
			templateUrl: 'templates/severidad/severidad-new.html',
			controller: 'severidadController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/severidad/:id', {
			templateUrl: 'templates/severidad/severidad-view.html',
			controller: 'severidadController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/riesgo/', {
			templateUrl: 'templates/riesgo/riesgo-list.html',
			controller: 'riesgoController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/riesgo/new', {
			templateUrl: 'templates/riesgo/riesgo-new.html',
			controller: 'riesgoController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/riesgo/:id', {
			templateUrl: 'templates/riesgo/riesgo-view.html',
			controller: 'riesgoController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/tipo_incidencia/', {
			templateUrl: 'templates/tipo_incidencia/tipo_incidencia-list.html',
			controller: 'tipoIncidenciaController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/tipo_incidencia/new', {
			templateUrl: 'templates/tipo_incidencia/tipo_incidencia-new.html',
			controller: 'tipoIncidenciaController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/tipo_incidencia/:id', {
			templateUrl: 'templates/tipo_incidencia/tipo_incidencia-view.html',
			controller: 'tipoIncidenciaController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/prioridad/', {
			templateUrl: 'templates/prioridad/prioridad-list.html',
			controller: 'prioridadController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/prioridad/new', {
			templateUrl: 'templates/prioridad/prioridad-new.html',
			controller: 'prioridadController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/prioridad/:id', {
			templateUrl: 'templates/prioridad/prioridad-view.html',
			controller: 'prioridadController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/tipo_trabajo/', {
			templateUrl: 'templates/tipo_trabajo/tipo_trabajo-list.html',
			controller: 'tipoTrabajoController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/tipo_trabajo/new', {
			templateUrl: 'templates/tipo_trabajo/tipo_trabajo-new.html',
			controller: 'tipoTrabajoController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/tipo_trabajo/:id', {
			templateUrl: 'templates/tipo_trabajo/tipo_trabajo-view.html',
			controller: 'tipoTrabajoController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/tipo_falla/', {
			templateUrl: 'templates/tipo_falla/tipo_falla-list.html',
			controller: 'tipoFallaController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/tipo_falla/new', {
			templateUrl: 'templates/tipo_falla/tipo_falla-new.html',
			controller: 'tipoFallaController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/tipo_falla/:id', {
			templateUrl: 'templates/tipo_falla/tipo_falla-view.html',
			controller: 'tipoFallaController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/causa_falla/', {
			templateUrl: 'templates/causa_falla/causa_falla-list.html',
			controller: 'causaFallaController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/causa_falla/new', {
			templateUrl: 'templates/causa_falla/causa_falla-new.html',
			controller: 'causaFallaController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/causa_falla/:id', {
			templateUrl: 'templates/causa_falla/causa_falla-view.html',
			controller: 'causaFallaController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/marca/', {
			templateUrl: 'templates/marca/marca-list.html',
			controller: 'marcaController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/marca/new', {
			templateUrl: 'templates/marca/marca-new.html',
			controller: 'marcaController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/marca/:id', {
			templateUrl: 'templates/marca/marca-view.html',
			controller: 'marcaController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/proveedor/', {
			templateUrl: 'templates/proveedor/proveedor-list.html',
			controller: 'proveedorController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/proveedor/new', {
			templateUrl: 'templates/proveedor/proveedor-new.html',
			controller: 'proveedorController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/proveedor/:id', {
			templateUrl: 'templates/proveedor/proveedor-view.html',
			controller: 'proveedorController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/proyecto/', {
			templateUrl: 'templates/proyecto/proyecto-list.html',
			controller: 'proyectoController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/proyecto/new', {
			templateUrl: 'templates/proyecto/proyecto-new.html',
			controller: 'proyectoController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/proyecto/:id', {
			templateUrl: 'templates/proyecto/proyecto-view.html',
			controller: 'proyectoController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/centro_costo/', {
			templateUrl: 'templates/centro_costo/centro_costo-list.html',
			controller: 'centroCostosController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/centro_costo/new', {
			templateUrl: 'templates/centro_costo/centro_costo-new.html',
			controller: 'centroCostosController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/centro_costo/:id', {
			templateUrl: 'templates/centro_costo/centro_costo-view.html',
			controller: 'centroCostosController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/usuario/', {
			templateUrl: 'templates/usuario/usuario-list.html',
			controller: 'usuariosController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/usuario/new', {
			templateUrl: 'templates/usuario/usuario-new.html',
			controller: 'usuariosController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/usuario/:id', {
			templateUrl: 'templates/usuario/usuario-view.html',
			controller: 'usuariosController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/cambiar-clave/', {
			templateUrl: 'templates/cambiar_clave/cambiar_clave_view.html',
			controller: 'usuariosController',
			resolve: { method: function () { return 'cambiarpass'; } }
		})
		.when('/empresa/', {
			templateUrl: 'templates/empresa/empresa-list.html',
			controller: 'empresasController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/empresa/new', {
			templateUrl: 'templates/empresa/empresa-new.html',
			controller: 'empresasController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/empresa/:id', {
			templateUrl: 'templates/empresa/empresa-view.html',
			controller: 'empresasController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/rol/', {
			templateUrl: 'templates/rol/rol-list.html',
			controller: 'rolesController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/rol/new', {
			templateUrl: 'templates/rol/rol-new.html',
			controller: 'rolesController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/rol/:id', {
			templateUrl: 'templates/rol/rol-view.html',
			controller: 'rolesController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/team/', {
			templateUrl: 'templates/team/team-list.html',
			controller: 'teamController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/team/new', {
			templateUrl: 'templates/team/team-new.html',
			controller: 'teamController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/team/:id', {
			templateUrl: 'templates/team/team-view.html',
			controller: 'teamController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/disponibilidad_equipo/', {
			templateUrl: 'templates/disponibilidad_equipo/disponibilidad_equipo-list.html',
			controller: 'disponibilidadEquipoController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/disponibilidad_equipo/new', {
			templateUrl: 'templates/disponibilidad_equipo/disponibilidad_equipo-new.html',
			controller: 'disponibilidadEquipoController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/disponibilidad_equipo/:id', {
			templateUrl: 'templates/disponibilidad_equipo/disponibilidad_equipo-view.html',
			controller: 'disponibilidadEquipoController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/vehiculo/', {
			templateUrl: 'templates/vehiculo/vehiculo-list.html',
			controller: 'vehiculoController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/vehiculo/new', {
			templateUrl: 'templates/vehiculo/vehiculo-new.html',
			controller: 'vehiculoController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/vehiculo/:id', {
			templateUrl: 'templates/vehiculo/vehiculo-view.html',
			controller: 'vehiculoController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/herramienta/', {
			templateUrl: 'templates/herramienta/herramienta-list.html',
			controller: 'herramientaController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/herramienta/new', {
			templateUrl: 'templates/herramienta/herramienta-new.html',
			controller: 'herramientaController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/herramienta/:id', {
			templateUrl: 'templates/herramienta/herramienta-view.html',
			controller: 'herramientaController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/cliente/', {
			templateUrl: 'templates/cliente/cliente-list.html',
			controller: 'clienteController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/cliente/new', {
			templateUrl: 'templates/cliente/cliente-new.html',
			controller: 'clienteController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/cliente/:id', {
			templateUrl: 'templates/cliente/cliente-view.html',
			controller: 'clienteController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/reportes/', {
			templateUrl: 'templates/reportes/reportes-list.html',
			controller: 'reportesController',
			resolve: { method: function () { return 'main'; } }
		})
		.when('/panel', {
			templateUrl: 'templates/estadisticas/dashboard.html',
			controller: 'panelController'
		})
		.when('/causa_falla_correctiva/', {
			templateUrl: 'templates/causa_falla_correctiva/causa_falla-list.html',
			controller: 'causaFallaCorrectivaController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/causa_falla_correctiva/new', {
			templateUrl: 'templates/causa_falla_correctiva/causa_falla-new.html',
			controller: 'causaFallaCorrectivaController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/causa_falla_correctiva/:id', {
			templateUrl: 'templates/causa_falla_correctiva/causa_falla-view.html',
			controller: 'causaFallaCorrectivaController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/problema_correctivo/', {
			templateUrl: 'templates/problema_correctivo/problema_correctivo-list.html',
			controller: 'problemaCorrectivoController',
			resolve: { method: function () { return 'list'; } }
		})
		.when('/problema_correctivo/new', {
			templateUrl: 'templates/problema_correctivo/problema_correctivo-new.html',
			controller: 'problemaCorrectivoController',
			resolve: { method: function () { return 'new'; } }
		})
		.when('/problema_correctivo/:id', {
			templateUrl: 'templates/problema_correctivo/problema_correctivo-view.html',
			controller: 'problemaCorrectivoController',
			resolve: { method: function () { return 'view'; } }
		})
		.when('/detalle/:tipo/:special', {
			templateUrl: function (attr) {

				if (attr.tipo.toLowerCase() == 'incidencia') {
					return 'templates/incidencia/incidencias-list.html';
				} else if (attr.tipo.toLowerCase() == 'ott') {
					return 'templates/ott/ott-list.html';
				} else if (attr.tipo.toLowerCase() == 'calendario') {
					return 'templates/estadisticas/ott-list.html';
				} else if (attr.tipo.toLowerCase() == 'preincidencia') {
					return 'templates/preincidencias/preincidencias-list.html';
				} else if (attr.tipo.toLowerCase() == 'inventario') {
					if (attr.special == '1') {
						return 'templates/inventario/inventario-stock-critico.html';
					} else {
						return 'templates/inventario/inventario-general.html';
					}
				};
			},
			controller: 'detalleController'
		})
		.when('/login', {
			templateUrl: 'templates/login/login.html',
			controller: 'loginController'
		})
		.when('/login/:next/:detail?', {
			templateUrl: 'templates/login/login.html',
			controller: 'loginController'
		})
		.otherwise('/panel');
}



// WEBPACK FOOTER //
// ./app/js/config/ng_route.js